import { render, staticRenderFns } from "./HrBasicCorpHis.vue?vue&type=template&id=5aa95c9a&scoped=true&"
import script from "./HrBasicCorpHis.vue?vue&type=script&lang=js&"
export * from "./HrBasicCorpHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa95c9a",
  null
  
)

export default component.exports